module.exports = __webpack_public_path__ + "mv.svg?f1beedaaf3f70d20d2e962a02d98c559";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/mv.svg
// module id = 1264
// module chunks = 0